import React from "react"
import { FormattedMessage, MessageDescriptor } from "react-intl"
import { Button, Stack, Typography } from "@carrotfertility/carotene-core"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"

interface CarrotPlanTileProps {
  messageText: MessageDescriptor
  buttonText: MessageDescriptor
  handleClick: () => void
}

export function CarrotPlanTile({ messageText, buttonText, handleClick }: CarrotPlanTileProps): JSX.Element {
  const { mutate: trackAction } = useMemberActionTracking()

  const handleButtonClick = () => {
    trackAction({
      memberActionTaken: MemberActions.HOMEPAGE_GET_CARROT_PLAN_CLICKED
    })
    handleClick()
  }

  return (
    <Stack
      gap={(theme) => theme.tokens.spacing.md}
      sx={{ maxInlineSize: "65%", marginBlockStart: (theme) => theme.spacing(theme.tokens.spacing.lg) }}
    >
      <Stack gap={(theme) => theme.tokens.spacing.xs}>
        <Typography variant="h3">
          <FormattedMessage defaultMessage="Get your Carrot Plan" />
        </Typography>
        <Typography margin={0} variant="body1" color={(theme) => theme.palette.text.secondary}>
          <FormattedMessage {...messageText} />
        </Typography>
      </Stack>
      <Stack alignItems="start">
        <Button onClick={handleButtonClick} color="secondary" variant="contained" fullWidth={false}>
          <FormattedMessage {...buttonText} />
        </Button>
      </Stack>
    </Stack>
  )
}
